/*
 * @Author: your name
 * @Date: 2022-03-03 21:23:53
 * @LastEditTime: 2022-03-25 22:17:44
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \www-pro\src\main.js
 */
import Vue from "vue";
import App from "./App.vue";
import QRCode from "qrcodejs2";
import axios from "axios";
import i18n, { setLocal } from "./lang/i18n";
import VueSlider from "vue-slider-component";
import { post, fetch, patch, put } from "./util/http";
import { globalBaseUrl } from "../public/config";
import ElementUI from "element-ui";
import echarts from "echarts";
import VueCountryIntl from "vue-country-intl";
import SlideVerify from "vue-monoplasty-slide-verify";
import router from "./router";
import store from "./store";
import { BIZ_TOKEN, BIZ_USERINFO, BIZ_LANG, BIZ_LANGUAGE_MAP } from "./common/constant";
// import * as socketApi from "./api/socket";
import VueAwesomeSwiper from "vue-awesome-swiper";
import HeaderView from "./components/header";
import FooterView from "./components/footer";
import CartView from "./components/cart";
import LoadingView from "./components/loading";
import OnlineServiceView from './components/customService'
import Big from 'big.js'
import "./assets/sass/index.scss";
import "vue-country-intl/lib/vue-country-intl.css";
import "vue-slider-component/theme/default.css";
import "../src/assets/css/index.css";
import "../src/assets/css/varCss.css";
import "../src/assets/css/public.css";
import "element-ui/lib/theme-chalk/index.css";
import "./element-#F89900/index.css";
import "element-ui/lib/theme-chalk/index.css";
import "./element-#F89900/index.css";
import "swiper/css/swiper.css";
import './assets/icons'
import './assets/iconfont/iconfont.css'
import vuePhotoZoomPro from 'vue-photo-zoom-pro'
import { gsap } from "gsap";
// IM 即时通讯：工具与全局组件
import imHttpRequest from "./imchat/api/httpRequest";
import * as imSocketApi from "./imchat/api/wssocket";
import * as imMessageType from "./imchat/api/messageType";
import imEmotion from "./imchat/api/emotion.js";
import imUrl from "./imchat/api/url.js";
import imElement from "./imchat/api/element.js";
import * as imEnums from "./imchat/api/enums.js";
import * as imDate from "./imchat/api/date.js";
import "./imchat/utils/directive/dialogDrag";
import ImChatPanel from "./imchat/components/ImChatPanel.vue";
Vue.prototype.$axios = axios;
Vue.prototype.$post = post;
Vue.prototype.$fetch = fetch;
Vue.prototype.$patch = patch;
Vue.prototype.$put = put;
Vue.prototype.$qrCode = QRCode;
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;
Vue.prototype.TITLE = process.env.VUE_APP_TITLE;
// Vue.prototype.socketApi = socketApi;
Vue.prototype.$GloExchangeRate = "00000";
Vue.prototype.$big = Big
Vue.prototype.$Gsap = gsap
Vue.prototype.publicGlobalUrl = globalBaseUrl
// IM 即时通讯全局挂载
Vue.prototype.$wsApi = imSocketApi;
Vue.prototype.$msgType = imMessageType;
Vue.prototype.$date = imDate;
Vue.prototype.$http = imHttpRequest;
Vue.prototype.$emo = imEmotion;
Vue.prototype.$url = imUrl;
Vue.prototype.$elm = imElement;
Vue.prototype.$enums = imEnums;
Vue.prototype.$eventBus = new Vue();

Vue.use(ElementUI);
Vue.use(SlideVerify);
Vue.use(router);
Vue.use(gsap);
import moment from "moment-timezone";
const formatZoneDate = (time) => {
  if (!time) return '--'
  //设置服务器默认时区
  moment.tz.setDefault('Asia/Shanghai')
  time = moment(time)
  //获取当前时区
  let timezone = moment.tz.guess(true)
  //time转成当前时区的时间
  time = moment.tz(time, timezone).format('YYYY-MM-DD HH:mm:ss')
  return time
}
Vue.prototype.$formatZoneDate = formatZoneDate
Vue.filter('formatZoneDate', formatZoneDate)
// Global registration component
Vue.component("VueSlider", VueSlider);
Vue.component(VueCountryIntl.name, VueCountryIntl);
Vue.component("EsHeaderView", HeaderView);
Vue.component("EsFooterView", FooterView);
Vue.component("CartView", CartView);
Vue.component("EsLoadingView", LoadingView);
Vue.component("EsOnlineServiceView", OnlineServiceView);
Vue.component("ImChatPanel", ImChatPanel);
Vue.use(VueAwesomeSwiper);
Vue.use(vuePhotoZoomPro)

const multiItem = {
  'BizSpring': {
    name: 'BizSpring',
    mail: 'BizSpring@bizspring.cn',
    bucket: 'ht-shop-test',
  },
  'Argos': {
    name: 'Argos',
    mail: 'support@argos.me',
    bucket: 'argos-shop-online',
  },
  'Mbuy': {
    name: 'Mbuy',
    mail: 'support@mbuy.world',
    bucket: 'ht-shop-test',
  },
  'Inchoi': {
    name: 'Inchoi',
    mail: 'support@inchoius.com',
    bucket: 'ht-shop-test',
  },
  'MetaShop': {
    name: 'MetaShop',
    mail: 'support@e-metashop.com',
    bucket: 'ht-shop-test',
  },
  'Hive': {
    name: 'Hive',
    mail: 'support@hivemalls.com'
  },
  'FamilyMart': {
    name: 'FamilyMart',
    mail: 'support@e-familymart.com'
  },
  'FamilyShop': {
    name: 'FamilyShop',
    mail: 'support@familyshopvip.com'
  },
  'Tongda':{
    name: 'Tongda',
    mail: 'support@tongdasvip.com'
  },
  'Shopee': {
    name: 'Shopee',
    mail: 'support@shopee-asiaus.com'
  },
  'TikTok': {
    name: 'TikTok',
    mail: 'support@tiktokmallit.com'
  },
  'Shop2u': {
      name: 'Shop2u',
      mail: 'support@shop2u.co'
  },
  "Green Mall": {
    name: "Green Mall",
    mail: 'support@greenmallus.com'
  },
  "SM-wholesale shop": {
    name: "SM-wholesale shop",
    mail: 'support@justshopvip.com'
  },
  "ArgosShop": {
    name: "ArgosShop",
    mail: "support@argosshopvip.com"
  },
  "Laz": {
    name: "Laz",
    mail: "support@lazshopvip.com"
  },
  "Iceland": {
    name: "Iceland",
    mail: "support@icelandmartvip.com"
  },
  "INT Overstock": {
    name: "INT Overstock",
    mail: "support@overstock8.me"
  },
  "TikTok-Wholesale":{
    name: "TikTok-Wholesale",
    mail: "support@wholesalesvip.com"
  }
}
Vue.prototype.$multiItem = multiItem
// import titleSmall from './components/titleSmall.vue';//引入组件
// Vue.component('title-small',titleSmall)//注册组件

// import FooterView from './components/footerView.vue';//引入组件
// Vue.component('FooterView',FooterView)//注册组件

// import listCoins from './components/listCoins.vue';//引入组件
// Vue.component('listCoins',listCoins)//注册组件

////import {tools} from './util/tools'
//Vue.use(tools)
const is_mobile = () => {
  var regex_match = /(nokia|iphone|android|motorola|^mot-|softbank|foma|docomo|kddi|up.browser|up.link|htc|dopod|blazer|netfront|helio|hosin|huawei|novarra|CoolPad|webos|techfaith|palmsource|blackberry|alcatel|amoi|ktouch|nexian|samsung|^sam-|s[cg]h|^lge|ericsson|philips|sagem|wellcom|bunjalloo|maui|symbian|smartphone|midp|wap|phone|windows ce|iemobile|^spice|^bird|^zte-|longcos|pantech|gionee|^sie-|portalmmm|jigs browser|hiptop|^benq|haier|^lct|operas*mobi|opera*mini|320x320|240x320|176x220)/i;
  var u = navigator.userAgent;
  if (null == u) {
    return true;
  }
  var result = regex_match.exec(u);
  if (null == result) {
    return false
  } else {
    return true
  }
}
const getUrlVal = (name) => {
  let url = location.href
  let urlStr = url?.split('?')[1]
  // 创建空对象存储参数
  let obj = {};
  // 再通过 & 将每一个参数单独分割出来
  let paramsArr = urlStr?.split('&')
  if (paramsArr) {
    for (let i = 0, len = paramsArr?.length; i < len; i++) {
      // 再通过 = 将每一个参数分割为 key:value 的形式
      let arr = paramsArr[i]?.split('=')
      obj[arr[0]] = arr[1];
    }
  }
  return obj[name]
}

if (is_mobile()) {
  // const goodsId = getUrlVal('id')
  // const storeId = getUrlVal('storeId')
  // const lang = localStorage.getItem('BIZ_LANG')

  
  // if (goodsId) {
  //   location.href = location.origin + '/wap/#/CommodityDetails?sellerGoodsId=' + goodsId + '&lang=' + lang
  // } else if (storeId) {
  //   location.href = location.origin + '/wap/#/shop?sellerId=' + storeId + '&lang=' + lang
  // } else {
    location.href = location.origin + '/shop'
  // }
  // if (goodsId) {
  //   location.href = location.origin + '/wap/#/CommodityDetails?sellerGoodsId=' + goodsId + '&lang=' + lang
  // } else if (storeId) {
  //   location.href = location.origin + '/wap/#/shop?sellerId=' + storeId + '&lang=' + lang
  // } else {
  //   location.href = location.origin + '/wap'
  // }
}

/** 在任意页面 created 发请求前，从 session 恢复网关所需的 Authorization / UserId，避免早于 App.vue mounted 的请求无头 */
function bootstrapShopAuthHeaders() {
  const token = sessionStorage.getItem(BIZ_TOKEN) || localStorage.getItem(BIZ_TOKEN);
  if (!token) return;
  let u = store.state.userInfo;
  if (!u || !u.id) {
    try {
      const raw = sessionStorage.getItem(BIZ_USERINFO) || localStorage.getItem(BIZ_USERINFO);
      if (raw) u = JSON.parse(raw);
    } catch (e) {
      u = null;
    }
  }
  if (!u || !u.id) return;
  const h = store.state.headers || {};
  if (h.Authorization && String(h.Authorization).trim()) return;
  store.commit("SETHANDERS", {
    authorization: "Bearer " + token,
    userId: u.id,
    username: u.username || u.mobile || "",
  });
}
bootstrapShopAuthHeaders();

function mountApp() {
  new Vue({
    render: (h) => h(App),
    router,
    i18n,
    store,
  }).$mount("#app");
}

/**
 * 挂载前先取全局开关（多语言/多币种），在首屏渲染前确定语言与开关状态：
 * - 关闭多语言：强制中文，进入即中文，无英文闪烁、无 reload；
 * - 开启多语言：清除"强制中文"残留并回到英文默认，进入即英文；
 * - 多币种开关写入 localStorage，供页头币种/语言切换组件首屏正确隐藏。
 */
function bootstrapGlobalSwitchesThenMount() {
  axios
    .get(globalBaseUrl + "/upms/member/setting/public", { timeout: 6000 })
    .then((res) => {
      const settings = (res && res.data && res.data.data) || {};
      const mlEnabled = !(settings.multiLanguageEnabled === false || settings.multiLanguageEnabled === "false");
      const mcEnabled = !(settings.multiCurrencyEnabled === false || settings.multiCurrencyEnabled === "false");
      localStorage.setItem("shop_multiLanguageEnabled", mlEnabled ? "true" : "false");
      localStorage.setItem("shop_multiCurrencyEnabled", mcEnabled ? "true" : "false");
      if (!mlEnabled) {
        localStorage.setItem("shop_langForced", "true");
        setLocal(BIZ_LANGUAGE_MAP.zhCN);
      } else if (localStorage.getItem("shop_langForced") === "true") {
        localStorage.removeItem("shop_langForced");
        setLocal(BIZ_LANGUAGE_MAP.en);
      }
      // #region agent log
      fetch('http://127.0.0.1:7740/ingest/a9351a5b-1e14-43d3-b4dd-3beb0ed6fb3c',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'1b1377'},body:JSON.stringify({sessionId:'1b1377',runId:'post-fix',hypothesisId:'D',location:'main.js:preMount',message:'flags resolved before mount',data:{mlEnabled:mlEnabled,mcEnabled:mcEnabled,langAfter:localStorage.getItem(BIZ_LANG),i18nLocale:i18n.locale},timestamp:Date.now()})}).catch(()=>{});
      // #endregion
    })
    .catch(() => { /* 取设置失败则按本地默认渲染，保证可用 */ })
    .finally(() => {
      mountApp();
    });
}

bootstrapGlobalSwitchesThenMount();

String.prototype.format = function (args) {
  if (arguments.length > 0) {
    var result = this;
    if (arguments.length == 1 && typeof args == "object") {
      for (var key in args) {
        var reg = new RegExp("({" + key + "})", "g");
        result = result.replace(reg, args[key]);
      }
    } else {
      for (var i = 0; i < arguments.length; i++) {
        if (arguments[i] == undefined) {
          return "";
        } else {
          var reg = new RegExp("({[" + i + "]})", "g");
          result = result.replace(reg, arguments[i]);
        }
      }
    }
    return result;
  } else {
    return this;
  }
};
